import React from 'react';
import Dialog from '@mui/material/Dialog';

import '../NodeItemDialog/NodeItemDialog.css';
import SyncIndicator from "../SyncIndicator/SyncIndicator";

/**
 * Affiche une fenêtre modale de chargement pendant une opération en cours.
 * @param {object} props
 * @param {boolean} props.isLoading
 * @param {boolean} [props.isDarkStyle]
 */
export default function DialogLoading( props ) {
	let css = "shadow-sm-dark rounded-sm cm-dialog-confirm";
	if( props.isDarkStyle ) {
		css += " dark";
	}

	return (
		<Dialog classes={{ paper: css }}
				aria-labelledby="simple-dialog-title" 
				open={Boolean(props.isLoading)}>
			<div className="text-center p-5">
				<SyncIndicator loading={true}
							   className={"display-4 spining space-top"}/>
			</div>
		</Dialog>
		
	);
}
